import type { HandleMentionsChangedProps, MentionType } from './hooks/useMentionsNotifications';

export const handleMentionsChanged = ({
	mentionChanges,
	deletedMentions,
	addedMentions,
	setDeletedMentions,
	setAddedMentions,
	userId,
	unrestrictedMentions,
	parentSpaceRestrictedMentions,
	pageRestrictedMentions,
	unrestrictedTasks,
	addedTasks,
	deletedTasks,
	setAddedTasks,
	setDeletedTasks,
	pageRestrictedTasks,
	parentSpaceRestrictedTasks,
	setMentionsAdded,
	setTasksAdded,
}: HandleMentionsChangedProps) => {
	// Process added mentions first
	const addedMentionsExcludingCurrentUser: MentionType[] = [];
	const addedTasksExcludingCurrentUser: MentionType[] = [];
	const currentUserAddedMentions: MentionType[] = []; // user mentioned themselves
	const currentUserAddedTasks: MentionType[] = [];

	mentionChanges.forEach((mentionChange) => {
		// we add user mentioning themselves so that we let backend know not to notify them
		if (mentionChange.id === userId) {
			if (mentionChange.type === 'added') {
				if (mentionChange?.taskLocalId) {
					currentUserAddedTasks.push(mentionChange);
				} else {
					currentUserAddedMentions.push(mentionChange);
				}
			}
		} else {
			if (mentionChange.type === 'added') {
				if (mentionChange?.taskLocalId) {
					addedTasksExcludingCurrentUser.push(mentionChange);
				} else {
					addedMentionsExcludingCurrentUser.push(mentionChange);
				}
			}
		}
	});

	if (currentUserAddedMentions.length > 0) {
		void setMentionsAdded({ currentUser: currentUserAddedMentions });
	}
	if (currentUserAddedTasks.length > 0) {
		void setTasksAdded({ currentUser: currentUserAddedTasks });
	}

	const currentAndNewAddedMentions = [...addedMentions, ...addedMentionsExcludingCurrentUser];
	const currentAndNewAddedTasks = [...addedTasks, ...addedTasksExcludingCurrentUser];

	if (addedMentionsExcludingCurrentUser.length > 0) {
		void setAddedMentions(currentAndNewAddedMentions);
	}
	if (addedTasksExcludingCurrentUser.length > 0) {
		void setAddedTasks(currentAndNewAddedTasks);
	}

	const currentAddedMentionsLocalIds = new Set([
		...unrestrictedMentions.map((mention) => mention.localId),
		...parentSpaceRestrictedMentions.map((mention) => mention.localId),
		...pageRestrictedMentions.map((mention) => mention.localId),
	]);
	const currentAddedTasksLocalIds = new Set([
		...unrestrictedTasks.map((mention) => mention.localId),
		...parentSpaceRestrictedTasks.map((mention) => mention.localId),
		...pageRestrictedTasks.map((mention) => mention.localId),
	]);

	// Process deleted mentions next, but only if they exist in the added mentions
	const validDeletedMentions: MentionType[] = [];
	const validDeletedTasks: MentionType[] = [];

	mentionChanges.forEach((mentionChange) => {
		if (mentionChange.id !== userId) {
			if (mentionChange.type === 'deleted') {
				if (currentAddedMentionsLocalIds.has(mentionChange.localId)) {
					validDeletedMentions.push(mentionChange);
				} else if (currentAddedTasksLocalIds.has(mentionChange.localId)) {
					validDeletedTasks.push(mentionChange);
				}
			}
		}
	});

	if (validDeletedMentions.length > 0) {
		void setDeletedMentions([...deletedMentions, ...validDeletedMentions]);
	}
	if (validDeletedTasks.length > 0) {
		void setDeletedTasks([...deletedTasks, ...validDeletedTasks]);
	}
};
